module.exports = __webpack_public_path__ + "static/seville-history-1-61c8c97197bd0e693a70a0d513f04f69.jpg";